import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { SITE_IMAGES } from '../../components/siteImages';
export function AdultBeginners() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-475">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-476">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-477">
          <div data-id="element-478">
            <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-479">
              For Beginners
            </div>
            <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-480">
              Adult Taekwondo for Beginners
            </h2>
            <p className="text-lg text-gray-warm mb-4" data-id="element-481">
              Storm adult classes are built for adults who have never trained —
              and for adults who trained years ago and want to come back. The
              drills are scaled to your fitness level, and the coaching meets
              you exactly where you are.
            </p>
            <p className="text-lg text-gray-warm mb-6" data-id="element-482">
              <span className="font-bold text-ink" data-id="element-483">
                Men and women, twenty-somethings through senior citizens
              </span>{' '}
              — every adult is welcome on the mat. Different ages and different
              fitness levels train side by side, and Storm coaches make sure
              every student is appropriately challenged.
            </p>
            <ul className="space-y-3" data-id="element-484">
              {['No prior martial arts experience needed', 'Drills scaled to your current fitness level', 'Inclusive of all ages, body types and backgrounds', 'Practical self-defense foundations woven into class'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-485">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-486" />
                  <span className="text-ink" data-id="element-487">{item}</span>
                </li>)}
            </ul>
          </div>
          <div data-id="element-488">
            <img src={SITE_IMAGES.adultClasses} alt="Adults training Taekwondo at Storm" className="block rounded-2xl shadow-xl w-full object-cover aspect-[4/3]" data-id="element-489" />
          </div>
        </div>
      </div>
    </section>;
}